module.exports = __webpack_public_path__ + "static/traditional-irish-banner.c2e54609.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/traditional-irish-banner.jpg
// module id = 639
// module chunks = 35783957827783